<template>
  <div class="agent-legend">
    <el-dropdown
      placement="top"
      :hide-on-click="false"
      @command="showFilteredAgentsByCriticality"
      @visible-change="hideFilteredAgentsByCriticality"
    >
      <span class="el-dropdown-link">
        Hosts by Criticality
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="Critical">
          <div
            class="box flex align-center gaps"
            @mouseover.stop.prevent="showFilteredAgentsByCriticality(criticalityEnum.CRITICAL)"
          >
            <div class="box nodesize-legend">
              <span class="offline-color nodesize-critical"></span>
            </div>
            <i class="display-block icon icon-criticality-critical" />
            <span class="box subtitle1">{{criticalityEnum.CRITICAL}}</span>
            <span class="box subtitle1">{{criticalAgents}}</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="Important">
          <div
            class="box flex align-center gaps"
            @mouseover.stop.prevent="showFilteredAgentsByCriticality(criticalityEnum.IMPORTANT)"
          >
            <div class="box nodesize-legend">
              <span class="offline-color nodesize-important"></span>
            </div>
            <i class="display-block icon icon-criticality-important" />
            <span class="box subtitle1">{{criticalityEnum.IMPORTANT}}</span>
            <span class="box subtitle1">{{importantAgents}}</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="Regular">
          <div
            class="box flex align-center gaps"
            @mouseover.stop.prevent="showFilteredAgentsByCriticality(criticalityEnum.REGULAR)"
          >
            <div class="box nodesize-legend">
              <span class="offline-color nodesize-regular"></span>
            </div>
            <i class="display-block icon icon-criticality-regular" />
            <span class="box subtitle1">{{criticalityEnum.REGULAR}}</span>
            <span class="box subtitle1">{{regularAgents}}</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { CriticalityLevelEnum } from "@/constants/criticality.constants";
export default {
  name: "AgentCriticalityLegend",
  props: {
    agents: { type: [Array, Object] }
  },
  data() {
    return {
      regularAgents: 0,
      importantAgents: 0,
      criticalAgents: 0,
      showFilteredAgentsByCriticality: undefined
    };
  },
  computed: {
    criticalityEnum() {
      return CriticalityLevelEnum;
    }
  },
  methods: {
    filterAgents() {
      let regulars = _.filter(this.agents, {
        criticality: CriticalityLevelEnum.REGULAR
      });
      let important = _.filter(this.agents, {
        criticality: CriticalityLevelEnum.IMPORTANT
      });
      let criticals = _.filter(this.agents, {
        criticality: CriticalityLevelEnum.CRITICAL
      });

      this.$set(this, "regularAgents", regulars.length);
      this.$set(this, "importantAgents", important.length);
      this.$set(this, "criticalAgents", criticals.length);
    },
    hideFilteredAgentsByCriticality(visible) {
      if (!visible) {
        this.showFilteredAgentsByCriticality("");
      }
    }
  },
  created() {
    this.showFilteredAgentsByCriticality = _.debounce(criticality => {
      this.$emit("display-criticality", criticality);
    }, 100);
  },
  mounted() {
    this.filterAgents();
  },
  watch: {
    agents: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal.length > 0) {
        this.filterAgents();
      }
    }
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/icon.css";

.nodesize-legend {
  width: 25px;
  height: 25px;
  line-height: 32px;

  > span {
    border-radius: 50%;
    display: inline-block;
    border: 1px solid;
  }
}

.criticality-title {
  span:first-child {
    margin-top: 1em;
  }

  span:nth-child(2) {
    margin-top: 1.5em;
  }

  span:last-child {
    margin-top: 0.5em;
  }
}

.nodesize-regular {
  width: 5px;
  height: 5px;
  margin-left: 5px;
  vertical-align: text-top;
}

.nodesize-important {
  width: 8px;
  height: 8px;
  margin-left: 3px;
  vertical-align: text-top;
}

.nodesize-critical {
  width: 12px;
  height: 12px;
}

.icon {
  margin: 0px;
}

.el-dropdown {
  cursor: pointer;
  border: 1px solid var(--border-color);
  padding: 6px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  color: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/legend/AgentCriticalityLegend.vue